<div class="p-2 bg-gray-50 min-h-screen">
  <!-- TABLE SECTION -->
  <div class=" ">
    <!-- TABLE HEADER -->
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold text-gray-800">{{ 'FACILITIES.TITLE' | translate }}</h3>
    </div>

    <!-- TABS -->
    <div class="flex flex-wrap gap-2 mb-4">
      <button
        (click)="setTab('all')"
        [ngClass]="activeTab === 'all' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'"
        class="px-4 py-2 rounded-lg"
      >
        {{ 'FACILITIES.TAB_ALL' | translate }}
      </button>

      <!-- VCM (LNLY_VCM) only -->
      @if (isVcm) {
        <button
          (click)="setTab('clientRecommendation')"
          [ngClass]="
            activeTab === 'clientRecommendation'
              ? 'bg-secondary text-white'
              : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_CLIENT_RECOMMENDATION' | translate }}
        </button>
      }

      <!-- Relationship Officer (LNLY_RO) only -->
      @if (isRelationshipOfficer) {
        <button
          (click)="setTab('pendingDrafts')"
          [ngClass]="
            activeTab === 'pendingDrafts' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_PENDING_DRAFTS' | translate }}
        </button>
      }

      <!-- Relationship Officer (LNLY_RO) / Team Lead (LNLY_TL) -->
      @if (isRoOrTeamLead) {
        <button
          (click)="setTab('clientApproval')"
          [ngClass]="
            activeTab === 'clientApproval' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_CLIENT_APPROVAL' | translate }}
        </button>

        <button
          (click)="setTab('roPendingReview')"
          [ngClass]="
            activeTab === 'roPendingReview' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_PENDING_REVIEW' | translate }}
        </button>
      }

      <!-- Shariah Advisory Committee (SAC) only -->
      @if (isSac) {
        <button
          (click)="setTab('sacReview')"
          [ngClass]="
            activeTab === 'sacReview' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_SAC_REVIEW' | translate }}
        </button>
      }

      <!-- Account Manager (LNLY_AM) only -->
      @if (isAccountManager) {
        <button
          (click)="setTab('pendingApproval')"
          [ngClass]="
            activeTab === 'pendingApproval' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_PENDING_ACTIONS' | translate }}
        </button>
      }

      <button
        (click)="setTab('approved')"
        [ngClass]="
          activeTab === 'approved' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
        "
        class="px-4 py-2 rounded-lg"
      >
        {{ 'FACILITIES.TAB_APPROVED' | translate }}
      </button>

      <!-- Account Manager (LNLY_AM) only -->
      @if (isAccountManager) {
        <button
          (click)="setTab('legalOpinion')"
          [ngClass]="
            activeTab === 'legalOpinion' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_LEGAL_OPINION' | translate }}
        </button>
      }

      <!-- Relationship Officer (LNLY_RO) only -->
      @if (isRelationshipOfficer) {
        <button
          (click)="setTab('extension')"
          [ngClass]="
            activeTab === 'extension' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_EXTENSION_LIST' | translate }}
        </button>
      }

      <!-- VCM (LNLY_VCM) only -->
      @if (isVcm) {
        <button
          (click)="setTab('pendingExtension')"
          [ngClass]="
            activeTab === 'pendingExtension'
              ? 'bg-secondary text-white'
              : 'bg-gray-200 text-gray-700'
          "
          class="px-4 py-2 rounded-lg"
        >
          {{ 'FACILITIES.TAB_PENDING_EXTENSIONS' | translate }}
        </button>
      }
    </div>

    <!-- ALL FO LETTERS -->
    @if (activeTab === 'all') {
      @if (creditProposalLoading) {
        <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_OFFER_LETTERS' | translate }}</div>
      }

      @if (creditProposalError) {
        <div class="text-sm text-red-600 mb-2">{{ creditProposalError | translate }}</div>
      }

      <app-table
        [columns]="creditProposalColumns"
        [data]="creditProposalList"
        [actions]="creditProposalActions"
        [enablePagination]="true"
        [pageSize]="10"
      >
      </app-table>
    }

    <!-- LEGAL OPINION (LNLY_AM) -->
    @if (activeTab === 'legalOpinion' && isAccountManager && !legalOpinionRow) {
      @if (legalOpinionListLoading) {
        <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_OFFER_LETTERS' | translate }}</div>
      }

      @if (legalOpinionListError) {
        <div class="text-sm text-red-600 mb-2">{{ legalOpinionListError | translate }}</div>
      }

      <app-table
        [columns]="legalOpinionColumns"
        [data]="legalOpinionList"
        [actions]="legalOpinionActions"
        [enablePagination]="true"
        [pageSize]="10"
      >
      </app-table>
    }

    <!-- LEGAL OPINION UPLOAD (selected letter) -->
    @if (activeTab === 'legalOpinion' && isAccountManager && legalOpinionRow) {
      <div class="flex justify-end mb-3">
        <app-back-button mode="custom" (back)="backToLegalOpinionList()"></app-back-button>
      </div>

      @if (legalOpinionLoading) {
        <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
      }

      @if (legalOpinionError) {
        <div class="text-sm text-red-600 mb-2">{{ legalOpinionError | translate }}</div>
      }

      <div class="bg-white rounded-2xl p-6">
        <!-- Legal Opinion | Facility Effective Date in the form's two-column grid; Attachments on the next row. -->
        <div>
          <app-dynamic-form #legalOpinionForm [fields]="legalOpinionFields" [model]="legalOpinionFormData">
          </app-dynamic-form>

          <div class="mt-6 sm:w-[calc(50%-0.75rem)] flex flex-col">
            <label class="form-label mb-2">
              {{ 'FACILITIES.ATTACHMENTS' | translate }}
              <span class="text-red-500">*</span>
            </label>

            <button
              type="button"
              class="form-input flex items-center gap-3 text-start cursor-pointer hover:border-indigo-500 transition"
              [class.border-red-500]="legalOpinionFileError"
              (click)="legalOpinionFileInput.click()"
            >
              <svg class="w-4 h-4 shrink-0 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                />
              </svg>

              <span class="flex-1 truncate" [class.text-gray-400]="!legalOpinionFile">
                {{ legalOpinionFile ? legalOpinionFile.name : ('DOCUMENT.CLICK_TO_UPLOAD_FILE' | translate) }}
              </span>
            </button>

            @if (legalOpinionFileError) {
              <div class="text-red-500 text-sm mt-1">{{ legalOpinionFileError | translate }}</div>
            }
          </div>
        </div>

        <input
          #legalOpinionFileInput
          type="file"
          [accept]="rowUploadAccept"
          class="hidden"
          (change)="onLegalOpinionFileSelected($event)"
        />

        <!-- Comment — same rich text editor as the credit proposal's Company Introduction. -->
        <div class="mt-8 border border-gray-200 rounded-xl bg-white p-5">
          <span class="block text-xs font-medium text-gray-400 uppercase tracking-wide mb-3">
            {{ 'FACILITIES.COMMENT' | translate }}
          </span>

          <app-rich-text-editor
            [(ngModel)]="legalOpinionComment"
            minHeight="120px"
            [placeholder]="'CREDIT_SECTION_PARAGRAPH.CONTENT_PLACEHOLDER' | translate"
          ></app-rich-text-editor>
        </div>

        <div class="flex justify-end mt-6">
          <button
            type="button"
            class="btn-primary"
            [disabled]="legalOpinionSaving"
            (click)="submitLegalOpinion()"
          >
            {{ (legalOpinionSaving ? 'COMMON.SAVING' : 'COMMON.SUBMIT') | translate }}
          </button>
        </div>
      </div>
    }

    <!-- CLIENT RECOMMENDATION (LNLY_VCM) -->
    @if (activeTab === 'clientRecommendation' && isVcm) {
      @if (clientRecommendationsLoading) {
        <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_CLIENT_RECOMMENDATIONS' | translate }}</div>
      }

      @if (clientRecommendationsError) {
        <div class="text-sm text-red-600 mb-2">{{ clientRecommendationsError | translate }}</div>
      }

      <app-table
        [columns]="clientRecommendationColumns"
        [data]="clientRecommendationList"
        [actions]="clientRecommendationActions"
        [enablePagination]="true"
        [pageSize]="10"
      >
      </app-table>
    }

    <!-- PENDING DRAFTS (LNLY_RO) -->
    @if (activeTab === 'pendingDrafts' && isRelationshipOfficer) {
      @if (pendingDraftClient) {
        <!-- Documents of the selected client -->
        <div class="flex justify-end mb-3">
          <app-back-button mode="custom" (back)="backToPendingDraftClients()"></app-back-button>
        </div>

        @if (pendingDraftDocsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
        }

        @if (pendingDraftDocsError) {
          <div class="text-sm text-red-600 mb-2">{{ pendingDraftDocsError | translate }}</div>
        }

        <app-table
          [columns]="pendingDraftDocColumns"
          [data]="pendingDraftDocList"
          [actions]="pendingDraftReadOnly ? [] : pendingDraftActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      } @else {
        @if (pendingDraftsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_PENDING_DRAFTS' | translate }}</div>
        }

        @if (pendingDraftsError) {
          <div class="text-sm text-red-600 mb-2">{{ pendingDraftsError | translate }}</div>
        }

        <app-table
          [columns]="pendingDraftColumns"
          [data]="pendingDraftList"
          [actions]="pendingDraftClientActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      }
    }

    <!-- CLIENT APPROVAL (LNLY_RO uploads the accepted copy; LNLY_TL views) -->
    @if (activeTab === 'clientApproval' && isRoOrTeamLead) {
      @if (clientApprovalClient) {
        <!-- Documents of the selected client -->
        <div class="flex justify-end mb-3">
          <app-back-button mode="custom" (back)="backToClientApprovalClients()"></app-back-button>
        </div>

        @if (clientApprovalDocsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
        }

        @if (clientApprovalDocsError) {
          <div class="text-sm text-red-600 mb-2">{{ clientApprovalDocsError | translate }}</div>
        }

        <app-table
          [columns]="clientApprovalDocColumns"
          [data]="clientApprovalDocList"
          [actions]="clientApprovalDocActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      } @else {
        @if (clientApprovalLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_CLIENT_APPROVALS' | translate }}</div>
        }

        @if (clientApprovalError) {
          <div class="text-sm text-red-600 mb-2">{{ clientApprovalError | translate }}</div>
        }

        <app-table
          [columns]="clientApprovalColumns"
          [data]="clientApprovalList"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      }
    }

    <!-- PENDING REVIEW (LNLY_RO approves / recommends; LNLY_TL views) -->
    @if (activeTab === 'roPendingReview' && isRoOrTeamLead) {
      @if (roReviewClient) {
        <div class="flex justify-end mb-3">
          <app-back-button mode="custom" (back)="backToRoReviewClients()"></app-back-button>
        </div>

        @if (roReviewDocsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
        }

        @if (roReviewDocsError) {
          <div class="text-sm text-red-600 mb-2">{{ roReviewDocsError | translate }}</div>
        }

        <app-table
          [columns]="roReviewDocColumns"
          [data]="roReviewDocList"
          [actions]="isRelationshipOfficer ? roReviewActions : []"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      } @else {
        @if (roReviewLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_PENDING_REVIEW' | translate }}</div>
        }

        @if (roReviewError) {
          <div class="text-sm text-red-600 mb-2">{{ roReviewError | translate }}</div>
        }

        <app-table
          [columns]="roReviewColumns"
          [data]="roReviewList"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      }
    }

    <!-- SAC REVIEW (SAC) -->
    @if (activeTab === 'sacReview' && isSac) {
      @if (sacReviewClient) {
        <div class="flex justify-end mb-3">
          <app-back-button mode="custom" (back)="backToSacReviewClients()"></app-back-button>
        </div>

        @if (sacReviewDocsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
        }

        @if (sacReviewDocsError) {
          <div class="text-sm text-red-600 mb-2">{{ sacReviewDocsError | translate }}</div>
        }

        <app-table
          [columns]="sacReviewDocColumns"
          [data]="sacReviewDocList"
          [actions]="sacReviewActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      } @else {
        @if (sacReviewLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_SAC_REVIEW' | translate }}</div>
        }

        @if (sacReviewError) {
          <div class="text-sm text-red-600 mb-2">{{ sacReviewError | translate }}</div>
        }

        <app-table
          [columns]="sacReviewColumns"
          [data]="sacReviewList"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      }
    }

    <!-- PENDING ACTIONS (LNLY_AM) — signed copies due (4813) and RO recommendations (4814) -->
    @if (activeTab === 'pendingApproval' && isAccountManager) {
      @if (pendingApprovalClient) {
        <!-- Documents of the selected client -->
        <div class="flex justify-end mb-3">
          <app-back-button mode="custom" (back)="backToPendingApprovalClients()"></app-back-button>
        </div>

        @if (pendingApprovalDocsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
        }

        @if (pendingApprovalDocsError) {
          <div class="text-sm text-red-600 mb-2">{{ pendingApprovalDocsError | translate }}</div>
        }

        <app-table
          [columns]="pendingApprovalDocColumns"
          [data]="pendingApprovalDocList"
          [actions]="pendingApprovalReadOnly ? [] : pendingApprovalActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      } @else {
        @if (pendingApprovalLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_PENDING_ACTIONS' | translate }}</div>
        }

        @if (pendingApprovalError) {
          <div class="text-sm text-red-600 mb-2">{{ pendingApprovalError | translate }}</div>
        }

        <app-table
          [columns]="pendingApprovalColumns"
          [data]="pendingApprovalList"
          [actions]="pendingApprovalClientActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      }
    }

    <!-- APPROVED FO LETTERS -->
    @if (activeTab === 'approved') {
      @if (approvedLettersLoading) {
        <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_APPROVED_LETTERS' | translate }}</div>
      }

      @if (approvedLettersError) {
        <div class="text-sm text-red-600 mb-2">{{ approvedLettersError | translate }}</div>
      }

      <app-table
        [columns]="creditProposalColumns"
        [data]="approvedLetterList"
        [actions]="creditProposalActions"
        [enablePagination]="true"
        [pageSize]="10"
      >
      </app-table>
    }

    <!-- EXTENTION LIST -->
    @if (activeTab === 'extension' && isRelationshipOfficer) {
      @if (extensionClient) {
        <!-- Documents of the selected client -->
        <div class="flex justify-end mb-3">
          <app-back-button mode="custom" (back)="backToExtensionClients()"></app-back-button>
        </div>

        @if (extensionDocsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
        }

        @if (extensionDocsError) {
          <div class="text-sm text-red-600 mb-2">{{ extensionDocsError | translate }}</div>
        }

        <app-table
          [columns]="extensionDocColumns"
          [data]="extensionDocList"
          [actions]="extensionReadOnly ? [] : extensionDocActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      } @else {
        @if (extensionLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_EXTENSION_LIST' | translate }}</div>
        }

        @if (extensionError) {
          <div class="text-sm text-red-600 mb-2">{{ extensionError | translate }}</div>
        }

        <app-table
          [columns]="extensionColumns"
          [data]="extensionList"
          [actions]="extensionClientActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      }
    }

    <!-- PENDING EXTENTIONS -->
    @if (activeTab === 'pendingExtension' && isVcm) {
      @if (pendingExtensionClient) {
        <!-- Documents of the selected client -->
        <div class="flex justify-end mb-3">
          <app-back-button mode="custom" (back)="backToPendingExtensionClients()"></app-back-button>
        </div>

        @if (pendingExtensionDocsLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_DOCUMENTS' | translate }}</div>
        }

        @if (pendingExtensionDocsError) {
          <div class="text-sm text-red-600 mb-2">{{ pendingExtensionDocsError | translate }}</div>
        }

        <app-table
          [columns]="extensionDocColumns"
          [data]="pendingExtensionDocList"
          [actions]="pendingExtensionReadOnly ? [] : pendingExtensionDocActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      } @else {
        @if (pendingExtensionLoading) {
          <div class="text-sm text-gray-500 mb-2">{{ 'FACILITIES.LOADING_PENDING_EXTENSIONS' | translate }}</div>
        }

        @if (pendingExtensionError) {
          <div class="text-sm text-red-600 mb-2">{{ pendingExtensionError | translate }}</div>
        }

        <app-table
          [columns]="pendingExtensionColumns"
          [data]="pendingExtensionList"
          [actions]="pendingExtensionClientActions"
          [enablePagination]="true"
          [pageSize]="10"
        >
        </app-table>
      }
    }
  </div>
</div>

<!-- EXTENSION REQUEST -->
<app-popup
  [(show)]="showExtensionRequestPopup"
  title="FACILITIES.REQUEST_EXTENSION"
  type="form"
  [fields]="extensionRequestFields"
  [data]="extensionRequestFormData"
  [onSave]="handleExtensionRequestSave"
></app-popup>

<!-- APPROVE / REJECT EXTENSION -->
<app-popup
  [(show)]="showGrantExtensionPopup"
  [title]="grantExtensionMode === 'approve' ? 'FACILITIES.APPROVE_EXTENSION' : 'FACILITIES.REJECT_EXTENSION'"
  type="form"
  [fields]="grantExtensionFields"
  [data]="grantExtensionFormData"
  [onSave]="handleGrantExtensionSave"
></app-popup>

<!-- REJECT RECOMMENDATION (VCM) -->
<app-popup
  [(show)]="showRejectRecommendationPopup"
  title="FACILITIES.REJECT_RECOMMENDATION"
  type="form"
  [fields]="rejectRecommendationFields"
  [data]="rejectRecommendationFormData"
  [onSave]="handleRejectRecommendationSave"
></app-popup>

<!-- PENDING REVIEW / SAC REVIEW: APPROVE, RECOMMEND, REJECT -->
@if (showDocDecisionPopup) {
  <app-popup
    [(show)]="showDocDecisionPopup"
    [title]="docDecisionTitle"
    type="form"
    [fields]="docDecisionFields"
    [data]="docDecisionFormData"
    [onSave]="handleDocDecisionSave"
  ></app-popup>
}

<!-- TERM PARAMETERS (VCM edit) — one tab per repayment term type -->
@if (showTermParamsPopup && !termParamsLoading) {
  <app-popup
    [(show)]="showTermParamsPopup"
    title="FACILITIES.TERM_PARAMETERS"
    type="custom"
    width="w-full max-w-4xl"
    [showCustomFooter]="true"
    primaryButtonText="COMMON.SAVE"
    [primaryButtonDisabled]="termParamsSaving || termParamTabs.length === 0"
    (primaryClick)="saveTermParams()"
  >
    @if (termParamTabs.length === 0) {
      <div class="text-sm text-gray-400">{{ 'FACILITIES.MSG.UNABLE_LOAD_TERM_PARAMS' | translate }}</div>
    } @else {
      <div class="mb-4 flex gap-6 border-b border-gray-100">
        @for (tab of termParamTabs; track $index; let i = $index) {
          <button
            type="button"
            class="pb-2 text-sm font-medium"
            [ngClass]="
              activeTermParamTab === i
                ? 'border-b-2 border-indigo-600 text-indigo-600'
                : 'text-gray-500 hover:text-indigo-600'
            "
            (click)="selectTermParamTab(i)"
          >
            {{ tab.label }}
          </button>
        }
      </div>

      <!-- Only the open tab's form is rendered; its values are kept in tab.model on switch. -->
      @for (tab of termParamTabs; track $index; let i = $index) {
        @if (activeTermParamTab === i) {
          <app-dynamic-form #termParamsForm [fields]="tab.fields" [model]="tab.model"></app-dynamic-form>
        }
      }

      <div class="mt-4">
        <label class="form-label mb-2 block" for="termParamsComment">{{ 'FACILITIES.COMMENT' | translate }}</label>
        <textarea
          id="termParamsComment"
          rows="3"
          class="form-input w-full"
          [(ngModel)]="termParamsComment"
        ></textarea>
      </div>
    }
  </app-popup>
}

<!-- RECOMMENDATION COMMENTS (VCM view) -->
<app-popup
  [(show)]="showRecommendationViewPopup"
  title="FACILITIES.RECOMMENDATION"
  type="custom"
  [showCustomFooter]="true"
>
  @if (recommendationViewLoading) {
    <div class="text-sm text-gray-500">{{ 'FACILITIES.LOADING_RECOMMENDATION' | translate }}</div>
  } @else if (recommendationComments.length === 0) {
    <div class="text-sm text-gray-400">{{ 'FACILITIES.NO_RECOMMENDATION_RECORDED' | translate }}</div>
  } @else {
    <div class="text-sm font-medium text-gray-700 mb-2">{{ 'FACILITIES.COMMENT' | translate }}</div>

    <ul class="space-y-3">
      @for (comment of recommendationComments; track $index) {
        <li class="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700">
          {{ comment }}
        </li>
      }
    </ul>
  }
</app-popup>

<!-- RECOMMENDATIONS (Pending Drafts — doc 36) -->
<app-popup
  [(show)]="showRecommendationPopup"
  title="FACILITIES.RECOMMENDATIONS"
  type="form"
  [fields]="recommendationFields"
  [data]="recommendationFormData"
  [onSave]="handleRecommendationSave"
></app-popup>

<!-- ROW UPLOAD — Client Approval accepted copy / AM signed copy / AM re-upload
     (same layout as the documents screens' upload popup) -->
@if (showRowUploadPopup) {
  <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div class="bg-white rounded-2xl w-[90%] max-w-2xl p-8 relative max-h-[90vh] overflow-y-auto">
      <button
        type="button"
        (click)="closeRowUploadPopup()"
        class="absolute top-6 end-6 w-10 h-10 rounded-full border flex items-center justify-center hover:bg-gray-100"
      >
        ✕
      </button>

      <h2 class="text-xl font-semibold mb-6">{{ rowUploadTitle | translate }}</h2>

      <app-dynamic-form
        #rowUploadForm
        [fields]="rowUploadFields"
        [model]="rowUploadFormData"
      >
      </app-dynamic-form>

      @if (rowUploadError) {
        <div class="text-red-500 text-sm mb-2 mt-3">{{ rowUploadError | translate }}</div>
      }

      <div
        class="border-2 border-dashed border-gray-300 rounded-2xl h-44 flex flex-col items-center justify-center cursor-pointer hover:border-indigo-500 transition mb-6 mt-4"
        (click)="rowUploadFileInput.click()"
      >
        <img src="images/upload.png" class="w-12 mb-2 opacity-70" />

        <p class="text-gray-500 text-sm">{{ 'DOCUMENT.CLICK_TO_UPLOAD_FILE' | translate }}</p>
      </div>

      @if (rowUploadFile) {
        <p class="text-xs text-green-600 mb-4 text-center">{{ rowUploadFile.name }}</p>
      }

      <input
        #rowUploadFileInput
        type="file"
        [accept]="rowUploadAccept"
        class="hidden"
        (change)="onRowUploadFileSelected($event)"
      />

      <div class="flex gap-4 mt-4">
        <button
          [disabled]="rowUploadSaving"
          (click)="triggerRowUploadSave()"
          class="px-6 py-2 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {{ 'DOCUMENT.SAVE' | translate }}
        </button>

        <button
          type="button"
          (click)="closeRowUploadPopup()"
          class="px-6 py-2 rounded-lg bg-red-500 text-white font-medium hover:bg-red-600"
        >
          {{ 'DOCUMENT.CANCEL' | translate }}
        </button>
      </div>
    </div>
  </div>
}

<!-- APPROVE DRAFT DOCUMENT CONFIRMATION -->
<app-popup
  [(show)]="showApproveDraftPopup"
  title="FACILITIES.APPROVE_DOCUMENT"
  type="confirm"
  [message]="approveDraftMessage"
  confirmText="COMMON.APPROVE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmApproveDraft()"
>
</app-popup>

<!-- OFFER LETTER DOCUMENTS MODAL -->
@if (showLetterDocumentPopup && selectedLetter) {
  <app-popup
    [(show)]="showLetterDocumentPopup"
    title="FACILITIES.OFFER_LETTER_DOCUMENTS"
    type="custom"
    width="w-full max-w-6xl"
  >
    <div class="space-y-6">
      <!-- SELECTED LETTER -->
      <div
        class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 rounded-xl border border-indigo-100 bg-indigo-50 px-4 py-3"
      >
        <div>
          <div class="text-xs font-medium text-gray-500">{{ 'FACILITIES.OFFER_LETTER_ID' | translate }}</div>

          <div class="text-sm font-semibold text-[#13258f]">
            {{ selectedLetter.crdtFoLtrSeq }}
          </div>
        </div>

        <div>
          <div class="text-xs font-medium text-gray-500">{{ 'FACILITIES.CREDIT_PROPOSAL_ID' | translate }}</div>

          <div class="text-sm font-semibold text-gray-800">
            {{ selectedLetter.crdtPrpslSeq }}
          </div>
        </div>

        <div>
          <div class="text-xs font-medium text-gray-500">{{ 'COMMON.STATUS' | translate }}</div>

          <div class="text-sm font-semibold text-gray-800">
            {{ selectedLetter.statusLabel | translate }}
          </div>
        </div>
      </div>

      <!-- SHARED DOCUMENT UPLOAD COMPONENT -->
      <app-document
        #letterDocuments
        [moduleSeq]="letterDocumentModuleSeq"
        [entitySeq]="selectedLetter.crdtFoLtrSeq!"
        [useFoLtrSaveApi]="true"
        [allowedDocSeqs]="letterDocumentAllowedDocSeqs"
        [lockSingleDocType]="isAccountManager"
        [visibleDocSeqs]="letterDocumentAllowedDocSeqs"
        [foLtrUploadGate]="true"
        [replaceExistingDocSeqs]="letterReplaceDocSeqs"
        [showUploadDateField]="true"
        [beforeDownload]="letterBeforeDownload"
        (documentsChange)="onLetterDocumentsChange($event)"
        (foLtrDocFlagsChange)="onLetterDocFlagsChange($event)"
        (foLtrDocSaved)="onLetterDocumentSaved()"
      >
      </app-document>

      @if (selectedLetter.status === 2691) {
        <p class="text-sm text-indigo-700">{{ 'FACILITIES.PRINT_HINT' | translate }}</p>
      } @else if (selectedLetter.status === 4810) {
        <p class="text-sm text-indigo-700">{{ 'FACILITIES.UPLOAD_PRINTED_COPY_HINT' | translate }}</p>
      }

      <div class="border-t border-gray-200 pt-5">
        <div class="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-3">
          <button
            type="button"
            class="w-full sm:w-auto px-6 py-2.5 rounded-lg border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50"
            (click)="closeLetterDocumentPopup()"
          >
            {{ 'COMMON.CLOSE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </app-popup>
}
